<div class="flex justify-between px-6 pt-6">
    <div class="flex items-center gap-3">
        <div class="flex justify-center items-center size-10 bg-[#F1F5F9] rounded-full p-2">
            <img src="/assets/images/shared/share-blue-icon.svg" alt="Share" class="h-auto w-5" />
        </div>
        <p class="text-xl text-[#0A0A0A] font-bold">Share Post</p>
    </div>

    <img
        src="/assets/images/shared/cross-black-icon.svg"
        alt="Close"
        class="h-6 w-6 cursor-pointer"
        (click)="onCancel()" />
</div>

<mat-dialog-content class="space-y-1">
    <div class="flex items-start gap-3 bg-[#F9FAFB] border border-[#E7EAF0] min-h-20 mt-2 rounded-2xl px-4 py-3">
        <img src="/assets/images/shared/link-grey-icon.svg" alt="Link" class="size-4 mt-1 shrink-0" />
        <p class="text-[#0A0A0A] text-[0.875rem] break-all leading-relaxed">
            {{ postLink() }}
        </p>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between gap-3">
    <button type="button" class="white-border-button flex-1 py-4 rounded-full" (click)="onCancel()">Close</button>
    <button type="button" class="border-button flex-1 py-4 rounded-full" (click)="copyLink()">
        <img src="/assets/images/shared/copy-white-icon.svg" alt="Copy" class="w-auto h-4 mr-4" />
        <p>Copy Link</p>
    </button>
</mat-dialog-actions>
